// Kalkulator kosztów importu auta z Japonii.
//
// Wspólne dla strony /kalkulator/ i kalkulatora przy aukcji — obie liczą
// dokładnie to samo, więc stawki i wzory żyją tutaj, żeby się nie rozjechały.
// Wszystkie kwoty wejściowe są w jenach (JPY), wynik w złotówkach po kursie NBP.

const NBP_RATE_URL = 'https://api.nbp.pl/api/exchangerates/rates/A/JPY/?format=json'

export const FALLBACK_RATE = 0.026
export const COMMISSION_PLN = 8000

const amount = (value) => Number(value) || 0

/** Opłaty aukcyjne: 8% ceny, ale nie mniej niż 650 000 JPY. */
export function auctionFee(priceJpy) {
  const price = amount(priceJpy)
  return price > 0 ? Math.max(price * 0.08, 650000) : 0
}

/** Opłata celna: 10% ceny wylicytowanej. */
export function customsFee(priceJpy) {
  return amount(priceJpy) * 0.1
}

/** Łączny koszt w PLN: auto + opłaty aukcyjne + cło + nasza prowizja. */
export function totalPln(priceJpy, rate) {
  const jpyRate = rate || FALLBACK_RATE
  const commissionJpy = COMMISSION_PLN / jpyRate
  const price = amount(priceJpy)
  return (auctionFee(price) + customsFee(price) + commissionJpy + price) * jpyRate
}

const money = (value, currency) =>
  `${amount(value).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`

export const pln = (value) => money(value, 'PLN')
export const jpy = (value) => money(value, 'JPY')

/**
 * Kurs JPY z NBP (tabela A). Gdy API nie odpowiada, `rate` jest `null` —
 * wtedy wyliczenia lecą po FALLBACK_RATE, a UI o tym informuje.
 */
export async function fetchJpyRate() {
  try {
    const { rates } = await (await fetch(NBP_RATE_URL)).json()
    return { rate: rates[0].mid, date: rates[0].effectiveDate }
  } catch (error) {
    return { rate: null, date: '' }
  }
}
